export const PlusIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" className={className}>
    <g clipPath="url(#clip0_2969_148678)">
      <path d="M12 1.5V23.5" stroke="#1D74FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 12.5H23" stroke="#1D74FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_2969_148678">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
